import { DraftSurveyTemplateQuestion } from "../../types";
import { Answers } from "./types";

export const SummaryView = ({
  questions,
  answers
}: {
  questions: DraftSurveyTemplateQuestion[];
  answers: Answers;
}) => (
  <div className="flex flex-col gap-4">
    <h2 className="text-xl font-bold text-content-1000">Survey complete</h2>
    <p className="text-sm text-content-400">
      Here is a summary of your answers.
    </p>
    <div className="flex flex-col gap-3 mt-2">
      {questions.map((q) => {
        const a = answers[q.index];
        const display = Array.isArray(a) ? a.join(", ") : a || "—";
        return (
          <div
            key={q.id}
            className="border border-alpha-100 rounded-lg p-4 bg-white"
          >
            <p className="text-xs text-content-300 font-medium mb-1">
              Question {q.index + 1}
            </p>
            <p className="text-sm font-medium text-content-700">
              {q.question || "Untitled question"}
            </p>
            <p className="text-sm text-content-1000 mt-1">{display}</p>
          </div>
        );
      })}
    </div>
  </div>
);
